import {Injectable} from '../../helpers';

export class MultidropdownSettingsService extends Injectable {

    static get $inject() {

        return [
            '$translate',
        ];
    }

    /**
     *
     * @param {Function} callback
     * @param {string|null} label
     * @return {Function}
     */
    labelFormatter(callback, label = 'label') {

        return selectedArray => {

            const filterArray = callback() || [];
            const filterLength = filterArray.length;

            const selectedArrayLength = selectedArray.length;

            if (selectedArrayLength === filterLength) {

                return this.$translate.instant('ALL_SELECTED');
            }

            if (selectedArrayLength === 1) {

                if (label === null) {

                    return selectedArray[0];
                }

                return selectedArray[0][label];
            }

            return `${selectedArrayLength} ${this.$translate.instant('OF')} ${filterLength}  ${this.$translate.instant('SELECTED')}`;
        };
    }

    translationText() {

        return {
            checkAll: this.$translate.instant('SELECT_ALL'),
            uncheckAll: this.$translate.instant('DESELECT_ALL'),
            buttonDefaultText: this.$translate.instant('NOTHING_SELECTED'),
            dynamicButtonTextSuffix: this.$translate.instant('CHECKED'),
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/services/multidropdown-settings.service.js